
import { useSelector } from 'react-redux'
import './App.css';
import { LoginForm } from './features/AuthForm/LoginForm'
import WelcPage from './components/main/welcompage/welcompage'
import SecondScreen from './components/main/second/second';
import ModalTest from './components/modules/modal/testModal'
import NotFound from './components/modules/404'
import { ContextModal } from './components/modules/modal/modalContext'
import './components/variable/variable.scss'
import {
  Route,
  Routes,
  Navigate,
  BrowserRouter
} from "react-router-dom"
import { useEffect, useState } from 'react';
import { RegisterForm } from './features/AuthForm/RegisterForm';
import InvitedMain from './components/main/second/mainbar/invite/InvitedMain';
import { Toaster } from 'sonner';
import { ForgotForm as ForgotPasswordPage } from './features/AuthForm/ForgotForm';
import { TwoFactorVerify as TwoFactorVerifyPage } from './features/AuthForm/TwoFactorVerify';
import { LINKS } from './components/Routs/config';
import { useKeyboardViewportLock } from './components/generic/hooks/useKeyboardViewportLock';



// iOS WKWebView (Chrome iOS / PWA) shrinks the viewport with the keyboard — pin the root to full height.
// A render-less leaf, so viewport resizes re-render only this component, not the whole app tree.
const KeyboardViewportLock = () => {
  useKeyboardViewportLock()
  return null
}

function App() {

  const [modal, setModal] = useState({
    open: false,
    value: ""
  })
  const user = useSelector(user => user?.mainReducer?.user)

  useEffect(() => {
    if ('orientation' in window.screen && window.screen.orientation.lock) {
      window.screen.orientation.lock('portrait').catch(console.error);
    }
  }, []);
  const isMobile = window.innerWidth < 768

  return (

     <BrowserRouter>
        <KeyboardViewportLock />
        <ContextModal.Provider value={[modal, setModal]} >
          {user ?
            <Routes>
                <Route path='/main/*' element={<SecondScreen/>} />
                <Route path='/invite/:id' element={<InvitedMain/>} />
                <Route path='/reset' element={<ForgotPasswordPage/>} />
                <Route path='*' element={<Navigate to='/main/azmanot' replace/>} />
            </Routes>
            :
            <Routes>
                <Route path='/home' element={<WelcPage/>} />
                <Route path='/invite/:id' element={<InvitedMain/>} />
                <Route path='/login' element={<LoginForm/>} />
                <Route path={LINKS.auth.twoFactorVerify.mainURL} element={<TwoFactorVerifyPage/>} />
                <Route path='/registration' element={<RegisterForm/>}/>
                <Route path='/reset' element={<ForgotPasswordPage/>} />
                <Route path='/' element={<LoginForm/>} />
                {/* rest password */}
                <Route path='*' element={<Navigate to='/login' replace/>} />
            </Routes>
          }
          <ModalTest />
          <Toaster
            position={isMobile ? 'bottom-right' : 'bottom-center'}
            visibleToasts={3}
            dir='rtl'
            richColors
            duration={2000}
            />
        </ContextModal.Provider>
     </BrowserRouter>

  );
}

export default App;
